import { Moment } from 'moment';
import { useConditionValueController } from '../../../../hooks/form';
import { AbsoluteDateValue } from '../../../../domain';
import { getDisplayDate } from '../utils';

export const useProcessAbsoluteDate = () => {
  const {
    field: { onChange },
  } = useConditionValueController();

  return (date: Moment) => {
    return onChange({ target: { value: new AbsoluteDateValue(getDisplayDate(date).toString()) } });
  };
};
